interface Question {
	id: string;
	question: string;
	department?: string; // Optional department field
}
export const getDefaultQuestions = (): Question[] => {
	return [
		// Sprint Planning questions - 20%
		{
			id: "q1",
			question: "Did the Product Owner approve the Sprint Scope?",
			department: "dept-1",
		},
		{
			id: "q2",
			question:
				"Did the Scrum Master prioritize the requirements based on client needs and discuss with product owner?",
			department: "dept-1",
		},
		{
			id: "q3",
			question:
				"Did the Scrum Master verify the tasks entered by Dev and QA teams?",
			department: "dept-1",
		},
		{
			id: "q4",
			question: "Did the client approve the commercials?",
			department: "dept-1",
		},
		{
			id: "q5",
			question: "Did the client share requirements via mail or Jira?",
			department: "dept-1",
		},
		{
			id: "q6",
			question:
				"Did the team sign off on all user stories before Sprint started?",
			department: "dept-1",
		},
		{
			id: "q7",
			question:
				"Did user stories include main requirements, implementation, and impact?",
			department: "dept-1",
		},
		{
			id: "q8",
			question:
				"Was a requirement discussion meeting held with the Scrum team?",
			department: "dept-1",
		},
		{
			id: "q9",
			question: "Were only approved user stories included in the Sprint scope?",
			department: "dept-1",
		},
		{
			id: "q10",
			question:
				"Were requirements converted into detailed user stories in Jira?",
			department: "dept-1",
		},

		// Development & Testing questions - 70%
		{
			id: "q11",
			question: "Did QA conduct retesting and regression testing?",
			department: "dept-2",
		},
		{
			id: "q12",
			question: "Did QA provide signoff once critical issues were fixed?",
			department: "dept-2",
		},
		{
			id: "q13",
			question: "Did QA team start testing post-acceptance test?",
			department: "dept-2",
		},
		{
			id: "q14",
			question: "Did QA team start writing test cases based on user stories?",
			department: "dept-2",
		},
		{
			id: "q15",
			question:
				"Did the Dev team start development based on tasks and design plan?",
			department: "dept-2",
		},
		{
			id: "q16",
			question: "Did the Dev team fix bugs and redeploy in QA environment?",
			department: "dept-2",
		},
		{
			id: "q17",
			question: "Did the Dev team update the status of bugs post-deployment?",
			department: "dept-2",
		},
		{
			id: "q18",
			question: "Was code review conducted and code rectified?",
			department: "dept-2",
		},
		{
			id: "q19",
			question: "Was time spent on development tracked in Jira?",
			department: "dept-2",
		},
		{
			id: "q20",
			question: "Were all tasks linked with user stories?",
			department: "dept-2",
		},
		{
			id: "q21",
			question: "Were bugs assigned to the Dev team?",
			department: "dept-2",
		},
		{
			id: "q22",
			question: "Were bugs entered in Jira with proper priority?",
			department: "dept-2",
		},
		{
			id: "q23",
			question: "Were bugs linked with user stories?",
			department: "dept-2",
		},
		{
			id: "q24",
			question:
				"Were some issues parked with PO's permission due to time constraints?",
			department: "dept-2",
		},
		{
			id: "q25",
			question: "Were sub-tasks created and mapped appropriately?",
			department: "dept-2",
		},
		{
			id: "q26",
			question: "Were tasks created for each user story in Jira?",
			department: "dept-2",
		},
		{
			id: "q27",
			question: "Were test cases linked to user stories in Jira?",
			department: "dept-2",
		},
		{
			id: "q28",
			question: "Were test cases reviewed and rectified as per feedback?",
			department: "dept-2",
		},
		{
			id: "q29",
			question: "Were unit test cases created and executed by the Dev team?",
			department: "dept-2",
		},
		{
			id: "q30",
			question: "Were user stories linked to the Sprint in Jira?",
			department: "dept-2",
		},

		// Deployment questions - 9%
		{
			id: "q31",
			question: "Did the Dev Lead confirm the backup?",
			department: "dept-3",
		},
		{
			id: "q32",
			question: "Was a backup of the current system taken before deployment?",
			department: "dept-3",
		},
		{
			id: "q33",
			question: "Was a release note prepared and sent to the client?",
			department: "dept-3",
		},
		{
			id: "q34",
			question: "Was deployment done in QA environment?",
			department: "dept-3",
		},
		{
			id: "q35",
			question: "Was the release deployed on UAT for client’s approval?",
			department: "dept-3",
		},
		{
			id: "q36",
			question:
				"Was the release deployed on the Prod environment post client signoff?",
			department: "dept-3",
		},
		{
			id: "q37",
			question: "Was the rollback script prepared for the database?",
			department: "dept-3",
		},
		{
			id: "q38",
			question: "Was the release tracker maintained?",
			department: "dept-3",
		},

		// Review & Retrospective questions - 1%
		{
			id: "q39",
			question: "Was a retrospective meeting held and tracked in Confluence?",
			department: "dept-4",
		},
		{
			id: "q40",
			question: "Was a review activity added in Jira?",
			department: "dept-4",
		},
		{
			id: "q41",
			question: "Was a review of the release process conducted?",
			department: "dept-4",
		},
		{
			id: "q42",
			question:
				"Was the Sprint’s success or failure decided in the retrospective meeting?",
			department: "dept-4",
		},
	];
};

export const titleCase = (str: any) => {
	if (str == null) return ""; // Handle null or undefined
	str = str.toString(); // Ensure str is a string
	str = str.replaceAll("_", " "); // Replace underscores with spaces
	return str.toLowerCase().replace(/\b(\w)/g, (s: any) => s.toUpperCase());
};




